import request from './axios';
import { baseUrl } from './config';

//转盘抽奖获取奖品和背景图
export const getTurntableConfig = (paramData) => request({
    url:baseUrl+'/test11',
    method: 'post',
    data:paramData
})
